import type { UIComponent } from '@gik/core/types/UI';
import bemBlock from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { HoverAnimation } from '@gik/ui/HoverAnimation';
import { HTMLParser } from '@gik/ui/HTMLParser';
import { Image } from '@gik/ui/Image';
import { KeepProportions } from '@gik/ui/KeepProportions';
import { FrameBone } from '@gik/ui/SkeletonLoader';
import React from 'react';

export type GiveSituationTileProps = {
  title?: string;
  imageUrl?: string;
  variant?: string;
  skeleton?: boolean;
} & UIComponent;

export const GiveSituationTileSkeleton = (): React.ReactElement => {
  const bem = bemBlock(`give-situation-tile-skeleton`);
  return (
    <div className={`${bem()}`}>
      <KeepProportions proportion={1}>
        <div className={bem('image-wrapper')}>
          <FrameBone className={bem('image')} />
        </div>
      </KeepProportions>
    </div>
  );
};

export function GiveSituationTileComp({
  className,
  title,
  variant,
  imageUrl,
  skeleton,
}: GiveSituationTileProps): React.ReactElement {
  const bem = bemBlock('give-situation-tile');

  if (!imageUrl || skeleton) return <GiveSituationTileSkeleton />;

  return (
    <HoverAnimation>
      <div className={bem(null, [{ [variant]: variant }], className)}>
        <KeepProportions proportion={1}>
          <div className={bem('box')}>
            <Image src={imageUrl} className={bem('image')} />
            <span className={bem('title')}>
              <HTMLParser rawHtml={title} />
            </span>
          </div>
        </KeepProportions>
      </div>
    </HoverAnimation>
  );
}

export const GiveSituationTile = withComponentErrorBoundary(GiveSituationTileComp);
